import { useSiteData } from "@/context/SiteDataContext";
import { waLink } from "@/lib/api";
import { EnquiryForm } from "./EnquiryForm";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { FullLogo } from "./Logo";

export const BookingEnquiry = ({ id, title, message, wa, idPrefix, tripType = "" }) => {
  const { settings } = useSiteData();
  return (
    <section id={id} className="container-x pt-20 scroll-mt-24" data-testid={`${idPrefix}-section`}>
      <div className="rounded-3xl bg-navy p-6 sm:p-10 lg:p-14 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5 text-white">
          <span className="inline-block rounded-2xl bg-white p-3"><FullLogo className="w-28" /></span>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl font-semibold">{title}</h2>
          <p className="mt-4 text-slate-300">Share your dates and number of guests. Our Andaman team will reply with available options and full details.</p>
          <a href={waLink(settings.whatsapp, wa)} target="_blank" rel="noreferrer" data-testid={`${idPrefix}-whatsapp`}
            className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-emerald-500 font-semibold hover:bg-emerald-600 transition-colors">
            <WhatsAppIcon className="h-5 w-5" /> Enquire on WhatsApp
          </a>
        </div>
        <div className="lg:col-span-7 rounded-2xl bg-white p-6 sm:p-8">
          <EnquiryForm idPrefix={idPrefix} defaultMessage={message} defaultTripType={tripType} />
        </div>
      </div>
    </section>
  );
};
